import React, { useMemo, useState } from 'react';
import cn from 'classnames';
import ArrowIcon from './img/arrow.component.svg';
import css from './desktopCustomIngredientsSelect.module.scss';
import { ICustomIngredientsSelectProps } from '../CustomIngredientsSelectDishRow.types';


export function DesktopCustomIngredientsSelect(props: ICustomIngredientsSelectProps) {
    const {
        selectedDishId,
        optionsList,
        checkIsSelected,
        onNextIdSelected,
        ingredientTypeText,
        replaceableIngredient,
        titleRenderField,
    } = props;
    const [isOpen, setIsOpen] = useState(false);

    const checkIsOpen = () => (isOpen ? 'open' : '');

    const titleShown = useMemo(
        () => {
            const selectedDish: any = optionsList.find((item: any) => item.id === selectedDishId);
            const selectedDishTitle = selectedDish?.name_upsell || selectedDish?.title;
            return titleRenderField === 'replaceableIngredient'
                ? replaceableIngredient
                : selectedDishTitle;
        },
        [optionsList, replaceableIngredient, titleRenderField, selectedDishId],
    );

    return (
        <div className={cn(css.selectIngredientsRoot, checkIsOpen())}>
            <button
                className={css.selectIngredientsButton}
                type="button"
                onClickCapture={(e) => {
                    e.stopPropagation();
                    setIsOpen(!isOpen);
                }}
            >
                <div className={css.selectIngredientsTextRow}>
                    <div className={css.ingredientType}>
                        {ingredientTypeText}
                        &nbsp;
                    </div>
                    <div className={css.ingredientValue}>
                        {titleShown}
                    </div>
                    {!isOpen && (
                        <div className={css.ingredientIcon}>
                            <ArrowIcon />
                        </div>
                    )}
                </div>
            </button>
            {isOpen && (
                <div className={css.selectIngredientsList}>
                    {optionsList.map((item: any) => (
                        <button
                            // @ts-ignore
                            className={cn(css.selectIngredientsListButton, checkIsSelected(item.id, selectedDishId))}
                            type="button"
                            onClick={() => {
                                onNextIdSelected(item.id);
                                setIsOpen(false);
                            }}
                            id={item.id}
                            key={item.id}
                        >
                            <div className={css.selectIngredientsListItemText}>
                                {item[titleRenderField] ? item[titleRenderField] : item?.title}
                            </div>
                        </button>

                    ))}
                </div>
            )}
        </div>
    );
}
